// extracted by mini-css-extract-plugin
export default {"restrictedContent":"src-app-components-RestrictedContent-style__didJH__restrictedContent"};